var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonBlueIconreact = function SvgButtonBlueIconreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 125.895"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1552",
    fill: "#2bd4db"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1550"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52859",
    d: "M53.334 53.333S54.551 3.042 106.667 0v53.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52860",
    d: "M106.667 53.333S107.884 3.042 160 0v53.333Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1551"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52861",
    d: "M106.667 72.561s-1.217 50.292-53.333 53.334V72.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52862",
    d: "M53.334 72.561S52.117 122.853 0 125.895V72.561Z"
  })))));
};

export default SvgButtonBlueIconreact;